import { ListingActionTypes } from './constants';

const INIT_STATE = {
    data: null,
    loading: false,
    error: null,
    updateSuccess: null,
    createSuccess: null,
};

const Listing = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ListingActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ListingActionTypes.CREATE_LISTING:
                    return { ...state, data: action.payload.data, loading: false, createSuccess: true };
                case ListingActionTypes.GET_LISTINGS:
                    return { ...state, data: action.payload.data, loading: false };
                case ListingActionTypes.GET_LISTING_BY_ID:
                    return { ...state, data: action.payload.data, loading: false };
                case ListingActionTypes.GET_LISTINGS_BY_USER:
                    return { ...state, data: action.payload.data, loading: false };
                case ListingActionTypes.UPDATE_LISTING:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                default:
                    return { ...state };
            }
        case ListingActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ListingActionTypes.CREATE_LISTING:
                    return { ...state, error: action.payload, loading: false };
                case ListingActionTypes.GET_LISTINGS:
                    return { ...state, error: action.payload, loading: false };
                case ListingActionTypes.GET_LISTING_BY_ID:
                    return { ...state, error: action.payload, loading: false };
                case ListingActionTypes.GET_LISTINGS_BY_USER:
                    return { ...state, error: action.payload, loading: false };
                case ListingActionTypes.UPDATE_LISTING:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                default:
                    return { ...state };
            }
        case ListingActionTypes.CREATE_LISTING:
            return { ...state, loading: true };
        case ListingActionTypes.GET_LISTINGS:
            return { ...state, loading: true };
        case ListingActionTypes.GET_LISTING_BY_ID:
            return { ...state, loading: true };
        case ListingActionTypes.GET_LISTINGS_BY_USER:
            return { ...state, loading: true };
        case ListingActionTypes.UPDATE_LISTING:
            return {
                ...state,
                id: action.payload.id,
                data: action.payload.data,
                loading: false,
            };
        case ListingActionTypes.RESET_LISTINGS:
            return INIT_STATE;
        default:
            return { ...state, updateSuccess: null, createSuccess: null };
    }
};

const ListingAccess = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ListingActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ListingActionTypes.GET_LISTING_ACCESS:
                    return { ...state, data: action.payload.data, loading: false };
                case ListingActionTypes.REVOKE_LISTING_ACCESS:
                    return { ...state, data: action.payload.data, loading: false };
                default:
                    return { ...state };
            }
        case ListingActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ListingActionTypes.GET_LISTING_ACCESS:
                    return { ...state, error: action.payload, loading: false };
                case ListingActionTypes.REVOKE_LISTING_ACCESS:
                    return { ...state, error: action.payload, loading: false };
                default:
                    return { ...state };
            }
        case ListingActionTypes.GET_LISTING_ACCESS:
            return { ...state, loading: true };
        case ListingActionTypes.REVOKE_LISTING_ACCESS:
            return { ...state, loading: true };
        default:
            return { ...state };
    }
};

export { Listing, ListingAccess };
